import { render, staticRenderFns } from "./DetailArchive.vue?vue&type=template&id=e52eddf6&"
import script from "./DetailArchive.vue?vue&type=script&lang=js&"
export * from "./DetailArchive.vue?vue&type=script&lang=js&"
import style0 from "./DetailArchive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports